module.exports = __webpack_public_path__ + "img/appltCourse-img26.652a2fe6.png";